module.exports = __webpack_public_path__ + "img/wcalogo.f94fa394.svg";